import React from 'react';
import PropTypes from 'prop-types';
import BackBtn from './BackBtn';

const Header = ({ title, backPath }) => (
  <div className="header">
    <BackBtn {...{ backPath }} />
    <div className="header__title">{title}</div>
  </div>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
  backPath: PropTypes.string
};

export default Header;
